import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { useSuspenseQuery } from '@tanstack/react-query'
import { EditUserForm, UserQueries } from '@portal/app-admin'

export const Route = createFileRoute('/_auth/preferences/users/$userId')({
  component: EditUserRoute,
  beforeLoad: ({ context: { scopedEnablements } }) => {
    if (!scopedEnablements.global().hasStandardEnablement('User', 'ADMIN')) {
      throw redirect({
        to: '/403',
        replace: true,
      })
    }
  },
  loaderDeps: ({ search: { orgId } }) => ({ orgId }),
  loader: ({ context: { queryClient }, params: { userId }, deps: { orgId } }) =>
    Promise.all([
      queryClient.ensureQueryData(UserQueries.detail(Number(userId), orgId)),
      queryClient.ensureQueryData(UserQueries.orgSettings(orgId)),
    ]),
})

function EditUserRoute() {
  const { userId } = Route.useParams()
  const { orgId } = Route.useSearch()
  const navigate = useNavigate()
  const { data: user } = useSuspenseQuery(UserQueries.detail(Number(userId), orgId))

  return (
    <EditUserForm
      user={user}
      orgId={orgId}
      onClose={() => navigate({ to: '/preferences/users' })}
    />
  )
}
